module.exports = "#version 300 es\n\nprecision highp float;\n\nin vec4 vs_Pos;\n\nout vec4 fs_Pos;\n\nuniform vec4 u_Resolution;\n\nvoid main() {\n\t// TODO: Pass relevant info to fragment\n\tgl_Position = vs_Pos;\n\tfs_Pos = vs_Pos;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/screenspace-vert.glsl
// module id = 64
// module chunks = 0